import { Image, ImageProps, Spinner } from '@chakra-ui/react';

export const Logo: React.FC<ImageProps> = (props): JSX.Element => (
  <Image fallback={<Spinner />} {...props} />
);

Logo.defaultProps = {
  fit: 'cover',
};
